import React from "react";
import { Box, Paper, Typography, LinearProgress } from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export default function WarmUpWidget({ data }) {
  if (!data) return null;
  const { stage, label, limit, daysRemaining, progress, isComplete, usedToday } = data;

  return (
    <Paper className="glass-card" sx={{ p: 3 }}>
      <Typography fontWeight={700} fontSize={15} color="#1e293b" mb={2}>Warm-Up Progress</Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
        {isComplete ? (
          <CheckCircleIcon sx={{ fontSize: 36, color: "#22c55e" }} />
        ) : (
          <RocketLaunchIcon sx={{ fontSize: 36, color: "#6366f1" }} />
        )}
        <Box sx={{ flex: 1 }}>
          <Typography fontWeight={700} fontSize={16} color="#1e293b">Stage {stage} — {label}</Typography>
          <Typography variant="caption" color="#64748b">
            {isComplete ? "Full access unlocked" : `${daysRemaining} days remaining · ${limit}/day limit`}
          </Typography>
        </Box>
      </Box>
      <LinearProgress variant="determinate" value={progress} sx={{ height: 8, borderRadius: 4, bgcolor: "#e2e8f0", mb: 1.5, "& .MuiLinearProgress-bar": { bgcolor: isComplete ? "#22c55e" : "#6366f1", borderRadius: 4 } }} />
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="caption" color="#64748b">{progress}% complete</Typography>
        <Typography variant="caption" color="#64748b">Used today: {usedToday}/{limit}</Typography>
      </Box>
      {!isComplete && (
        <Box sx={{ mt: 2, p: 1.5, borderRadius: 2, bgcolor: "rgba(99,102,241,0.06)", border: "1px solid #c7d2fe" }}>
          <Typography variant="body2" color="#4338ca" fontWeight={600} fontSize={12}>
            Stage {stage + 1 <= 4 ? stage + 1 : 4}: {stage + 1 <= 4 ? `${limit === 50 ? 100 : limit === 100 ? 250 : "Unlimited"}/day` : "Full access"}
          </Typography>
        </Box>
      )}
    </Paper>
  );
}
